import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as jwt_decode from 'jwt-decode';
import { Observable, Subject } from 'rxjs';
import { ExportToCsv } from 'export-to-csv';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  // showSidebar = true;
  studentId;

  planChangeRequestFlag;

  couponBoughtChildResponse;

  private subject = new Subject<any>();

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      session: localStorage.getItem('pp_session')
    })
  };

  httpOptionsImg = {
    headers: new HttpHeaders({
      session: localStorage.getItem('pp_session')
    })
  };

  constructor(private http: HttpClient) { }

  // Sidebar toggle on mobile START
  // setSidebarFlag() {
  //   this.showSidebar = !this.showSidebar;
  //   this.subject.next(this.showSidebar);
  // }

  // getSidebarFlag(): Observable<any> {
  //   return this.subject.asObservable();
  // }
  // Sidebar toggle on mobile END


  decodeToken() {
    const token = localStorage.getItem('pp_token');
    return (jwt_decode(token));
  }


  uploadImage(data) {
    console.log(data);
    return this.http.post<any>(environment.baseUrl + 'uploadImage', data);
  }

  // Get Branding OR Information OR Testimonials Data
  getPartnerData(data) {
    return this.http.post<any>(environment.baseUrl + 'getPartnerData', data, this.httpOptions);
  }

  // Branding
  setBrandingDetails(data) {
    return this.http.post<any>(environment.baseUrl + 'brandingUpdates', data, this.httpOptions);
  }

  // Add Testimonials
  setTestimonialsDetails(data) {
    return this.http.post<any>(environment.baseUrl + 'testimonialsUpdates', data, this.httpOptions);
  }

  // Remove Testimonials
  removeTestimonial(data) {
    return this.http.post<any>(environment.baseUrl + 'testimonialRemove', data, this.httpOptions);
  }



  // Information
  setInformationDetails(data) {
    return this.http.post<any>(environment.baseUrl + 'informationUpdates', data, this.httpOptions);
  }

  // Information Image
  uploadInformationImage(data) {
    console.log(data);
    return this.http.post<any>(environment.baseUrl + 'informationUpdates', data, this.httpOptionsImg);
  }

  // Organization Details
  getOrganizationDetails() {
    return this.http.get<any>(environment.baseUrl + 'getOrgnization', this.httpOptions);
  }

  setOrganizationDetails(data) {
    return this.http.post<any>(environment.baseUrl + 'postOrgnization', data, this.httpOptions);
  }

  // My Team
  getTeamList(data) {
    return this.http.post<any>(environment.baseUrl + 'getTeam', data, this.httpOptions);
  }

  sendInvitations(data) {
    return this.http.post<any>(environment.baseUrl + 'sendInvitation', data, this.httpOptions);
  }

  getTeamListForCsvDownload(data) {
    return this.http.post<any>(environment.baseUrl + 'downloadTeamCsv', data, this.httpOptions);
  }

  // Export to CSV
  exportToCsvService(fileName, data) {

    const options = {
      fieldSeparator: ',',
      filename: fileName,
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: '',
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
    };

    const csvExporter = new ExportToCsv(options);

    csvExporter.generateCsv(data);
  }

  teamMemberAction(data) {
    return this.http.post<any>(environment.baseUrl + 'markCounselor', data, this.httpOptions);
  }

  uploadMemberImage(data) {
    return this.http.post<any>(environment.baseUrl + 'uploadCounselorImage', data, this.httpOptionsImg);
  }

  updateMember(data) {
    return this.http.post<any>(environment.baseUrl + 'updateCounselorData', data, this.httpOptions);
  }

  sendResetPasswordLink(data) {
    return this.http.post<any>(environment.baseUrl + 'sendResetPasswordLinkToCounselor', data, this.httpOptions);
  }

  // subscription upgrade
  getSubscriptionDetails(data) {
    return this.http.post<any>(environment.baseUrl + 'subscriptionDetails', data, this.httpOptions);
  }

  createSubscription(data) {
    return this.http.post<any>(environment.baseUrl + 'createSubscription', data, this.httpOptions);
  }

  razorpayAuthDetails(data) {
    console.log('api -', data);
    return this.http.post<any>(environment.baseUrl + 'authDetails', data, this.httpOptions);
  }


  // student list
  getStudentList(data) {
    return this.http.post<any>(environment.baseUrl + 'studentList', data, this.httpOptions);
  }

  // Assign Counselor
  assignStudentToCounselor(data) {
    return this.http.post<any>(environment.baseUrl + 'assignCounselor', data, this.httpOptions);
  }

  // Student Profile tab flag Observables
  setProfileTabFlag(data) {
    this.subject.next(data);
  }

  getProfileTabFlag(): Observable<any> {
    return this.subject.asObservable();
  }
  // Student Profile tab flag


  // Student Profile

  // Student info
  studentInfo(data) {
    return this.http.post<any>(environment.baseUrl + 'studentDetailedInfo', data, this.httpOptions);
  }

  // Matches
  studentMatches(data) {
    return this.http.post<any>(environment.baseUrl + 'studentMatchesInfo', data, this.httpOptions);
  }

  // Notes
  getStudentNotes(data) {
    return this.http.post<any>(environment.baseUrl + 'studentNotesInfo', data, this.httpOptions);
  }

  addQuickNote(data) {
    return this.http.post<any>(environment.baseUrl + 'addQuickNote', data, this.httpOptions);
  }

  addDetailedNote(data) {
    return this.http.post<any>(environment.baseUrl + 'addNote', data, this.httpOptions);
  }

  // Tests
  getStudentTestResults(data) {
    return this.http.post<any>(environment.baseUrl + 'studentTestInfo', data, this.httpOptions);
  }


  /*Tabs flag*/
  tabsFlag(data) {
    return data;
  }

  // Billing & Invoices
  getBillingInfoPageDetails() {
    return this.http.get<any>(environment.baseUrl + 'billingInformation', this.httpOptions);
  }

  getSubscriptionId() {
    return this.http.get<any>(environment.baseUrl + 'getSubscriptionId', this.httpOptions);
  }

  updateCardDetails(data) {
    return this.http.post<any>(environment.baseUrl + 'updateCardDetails', data, this.httpOptions);
  }

  updateBillingInformationDetails(data) {
    return this.http.post<any>(environment.baseUrl + 'updateBillingInformation', data, this.httpOptions);
  }

  sendBillOnEmail(data) {
    return this.http.post<any>(environment.baseUrl + 'sendBillOnEmail', data, this.httpOptions);
  }

  getBills(data) {
    return this.http.post<any>(environment.baseUrl + 'getBills', data, this.httpOptions);
  }


  // Upgrade and Billing-Invoices - Common (plan-action-modals)
  updateSubscription(data) {
    return this.http.post<any>(environment.baseUrl + 'updateSubscription', data, this.httpOptions);
  }

  cancelSubscription() {
    return this.http.get<any>(environment.baseUrl + 'cancelSubscription', this.httpOptions);
  }

  beforeDowngrade(data) {
    return this.http.post<any>(environment.baseUrl + 'beforeDowngrade', data, this.httpOptions);
  }

  disableCounselors(data) {
    return this.http.post<any>(environment.baseUrl + 'disableCounselors', data, this.httpOptions);
  }

  // Observable methods for disable and message if a subscription change request is made
  setPlanChangeRequestFlag(value) {
    this.planChangeRequestFlag = value;
    this.subject.next(this.planChangeRequestFlag);
  }

  getPlanChangeRequestFlag(): Observable<any> {
    return this.subject.asObservable();
  }


  // Assessment & Codes

  // returns Coupons Stats + Purchase plans pricing table data
  getPartnerCouponDetails() {
    return this.http.get<any>(environment.baseUrl + 'getPartnerCouponDetails', this.httpOptions);
  }

  getPriceForCoupons(data) {
    return this.http.post<any>(environment.baseUrl + 'getPriceForCoupons', data, this.httpOptions);
  }

  assignAdditionalCoupons(data) {
    return this.http.post<any>(environment.baseUrl + 'assignAdditionalCoupons', data, this.httpOptions);
  }

  // Observable methods for Coupons Bought Success
  setCouponBoughtFlag(count, amount) {
    this.couponBoughtChildResponse = {
      couponCount: count,
      couponAmount: amount
    };
    this.subject.next(this.couponBoughtChildResponse);
  }

  getCouponBoughtFlag(): Observable<any> {
    return this.subject.asObservable();
  }

  getPurchasedCouponsList(data) {
    return this.http.post<any>(environment.baseUrl + 'getCoupons', data, this.httpOptions);
  }

  assignPurchasedCoupon(data) {
    return this.http.post<any>(environment.baseUrl + 'generateCoupon', data, this.httpOptions);
  }

  // Exam Corner
  getExamFiltersData() {
    return this.http.get<any>(environment.baseUrl + 'getExamFilters', this.httpOptions);
  }

  getExamsList(data) {
    return this.http.post<any>(environment.baseUrl + 'getExamsList', data, this.httpOptions);
  }

  getCollegeListForExam(data) {
    return this.http.post<any>(environment.baseUrl + 'getCollegeList', data, this.httpOptions);
  }

  getExamDetails(data) {
    return this.http.post<any>(environment.baseUrl + 'getExamsDetails', data, this.httpOptions);
  }

  addExamsToPartnerBucket(data) {
    return this.http.post<any>(environment.baseUrl + 'addExamsToPartnerBucket', data, this.httpOptions);
  }

  getSubscribedExamsList() {
    return this.http.get<any>(environment.baseUrl + 'getSubscribedExamsList', this.httpOptions);
  }

  // Scholarships
  // refer separate file - scholarships.service.ts


  // Roadmap
  // Roadmap tab flag Observables
  setRoadmapTabFlag(data) {
    this.subject.next(data);
  }

  getRoadmapTabFlag(): Observable<any> {
    return this.subject.asObservable();
  }

}
